import React from 'react';
import ReactDOM from 'react-dom/client'; // Import Client API cho React 18
import './index.css'; // File CSS cơ bản (tùy chọn)
import App from './App'; // Import Component chính của bạn

// React 18 sử dụng createRoot
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* Component App chứa toàn bộ logic ứng dụng tiệm Nail của bạn */}
    <App />
  </React.StrictMode>
);

// Nếu bạn đang dùng React phiên bản cũ hơn (React 17 trở xuống), 
// code sẽ là:
// ReactDOM.render(<App />, document.getElementById('root'));